import store from "@/store";

export default {
  calculateTotalSuggestedRetailPrice({ commit }) {
    const skus = store.getters["kits/getKitSkus"];
    const productTotalRetailPrice = {};

    skus.forEach((sku) => {
      const productIdentifier = sku.sku;
      const totalPrice = sku.retailPrice * sku.quantity;

      if (!productTotalRetailPrice[productIdentifier]) {
        productTotalRetailPrice[productIdentifier] = 0;
      }

      productTotalRetailPrice[productIdentifier] += totalPrice;
    });

    const totalSuggestedRetailPrice = Object.values(
      productTotalRetailPrice
    ).reduce((sum, value) => sum + value, 0);
    const parsedTotalSuggestedRetailPrice = parseFloat(
      totalSuggestedRetailPrice
    ).toFixed(2);
    // console.log(
    //   "parsedTotalSuggestedRetailPrice",
    //   parsedTotalSuggestedRetailPrice
    // );

    commit(
      "UPDATE_KIT_TOTAL_SUGGESTED_RETAIL_PRICE",
      parsedTotalSuggestedRetailPrice
    );
  },

  calculateTotalCOGS({ commit }, { shipmentCost, packageCost }) {
    const skus = store.getters["kits/getKitSkus"];
    console.log("skus", skus);

    console.log("shipmentCost", shipmentCost);
    console.log("packageCost", packageCost);

    const productTotalCost = {};

    skus.forEach((sku) => {
      console.log("sku", sku);
      console.log("sku.cogs", sku.cogs);
      console.log("sku.quantity", sku.quantity);
      const productIdentifier = sku.sku;
      const totalCost = sku.cogs * sku.quantity;

      if (!productTotalCost[productIdentifier]) {
        productTotalCost[productIdentifier] = 0;
      }

      productTotalCost[productIdentifier] += totalCost;
    });

    const productCost = Object.values(productTotalCost).reduce(
      (sum, value) => sum + value,
      0
    );
    console.log("productCost", productCost);

    const shippingAndPackagingCosts = shipmentCost + packageCost;
    console.log("shippingAndPackagingCosts", shippingAndPackagingCosts);

    const totalCOGS = productCost + shippingAndPackagingCosts;
    console.log("totalCOGS", totalCOGS);

    console.log("total cogs", totalCOGS);
    commit("UPDATE_KIT_TOTAL_COGS", totalCOGS);
  },

  updateFinalRetailPrice({ commit }, retailPrice) {
    // console.log("updated retailPrice", retailPrice);
    commit("UPDATE_KIT_FINAL_RETAIL_PRICE", retailPrice);
  },

  calculatePercentMargin({ commit }, { dollarMargin, finalRetailPrice }) {
    const percentMargin = (dollarMargin / finalRetailPrice) * 100;
    const parsedPercentMargin = parseFloat(percentMargin).toFixed(2);

    // console.log("updated percentMargin", parsedPercentMargin);
    commit("UPDATE_KIT_PERCENT_MARGIN", parsedPercentMargin);
  },

  addSkuToKit({ commit }, skuToAdd) {
    const skus = store.getters["kits/getKitSkus"];
    console.log("sku to add: ", skuToAdd);
    let kitSkuExists = false;

    skus.map((product) => {
      if (product.sku === skuToAdd.sku) {
        product.quantity++;
        kitSkuExists = true;
      }
    });

    if (!kitSkuExists) {
      const newKitSku = skuToAdd;
      newKitSku.quantity = 1;
      skus.push(newKitSku);
    }

    const skusAndQuantities = skus.map((product) => ({
      sku: product.sku,
      quantity: product.quantity,
    }));

    commit("UPDATE_NEW_KIT_SKUS", skusAndQuantities);
    commit("UPDATE_KIT_SKUS", skus);
  },
  removeSkuFromKit({ commit }, skuToRemove) {
    const skus = store.getters["kits/getKitSkus"];
    skus.map((product) => {
      if (product.sku === skuToRemove.sku && product.quantity > 1) {
        product.quantity--;
      } else if (product.sku === skuToRemove.sku && product.quantity === 1) {
        const removedSku = skus.findIndex(
          (product) => product.sku === skuToRemove.sku
        );
        skus.splice(removedSku, 1);
      }
    });

    const skusAndQuantities = skus.map((product) => ({
      sku: product.sku,
      quantity: product.quantity,
    }));

    commit("UPDATE_NEW_KIT_SKUS", skusAndQuantities);
    commit("UPDATE_KIT_SKUS", skus);
  },
  addProductToKitSummary({ commit }, productToAdd) {
    const kitProducts = store.getters["kits/getKitSummaryProducts"];
    // let skus;
    let kitSkuExists = false;

    kitProducts.map((product) => {
      if (product.sku === productToAdd.sku) {
        product.quantity++;
        kitSkuExists = true;
      }
    });

    if (!kitSkuExists) {
      const newSku = productToAdd;
      newSku.quantity = 1;
      // skus.push(newSku);
      kitProducts.push(newSku);
    }

    const skusAndQuantities = kitProducts.map((product) => ({
      sku: product.sku,
      quantity: product.quantity,
    }));

    commit("UPDATE_NEW_KIT_SKUS", skusAndQuantities);
    commit("UPDATE_KIT_SKUS", kitProducts);
  },
  setSkus({ commit }, skus) {
    const currentSkus = skus;
    const skusAndQuantities = currentSkus.map((product) => ({
      sku: product.sku,
      quantity: product.quantity,
    }));
    // console.log("skusAndQuantities", skusAndQuantities);
    commit("UPDATE_NEW_KIT_SKUS", skusAndQuantities);
    commit("UPDATE_KIT_SKUS", skus);
    // commit("SET_KIT_SKUS", skus);
  },

  resetSkus({ commit }, skus) {
    commit("UPDATE_KIT_SKUS", skus);
  },

  activateQuickEdit({ commit }) {
    commit("setQuickEditActive", true);
  },
  deactivateQuickEdit({ commit }) {
    commit("setQuickEditActive", false);
  },
};
